import PropTypes from "prop-types";
import React, { useContext, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {Button, FormHelperText, Grid, Link, InputAdornment, IconButton, TextField, Stack, Snackbar, Alert, Typography} from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import {EyeOutlined,EyeInvisibleOutlined} from "@ant-design/icons";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE, LOGIN_PAGE, PLACEHOLDER } from "../../shared/constants";
import AuthWrapper from "../../components/Authwrapper";
import { AuthApiService } from "../../services/api/AuthApiService";
import AuthContext from "../../services/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const {login} =useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [snackData, setSnackData] = useState({
    show: false,
    message: "",
    type: "error",
  });
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  useEffect(() => {
    // Trigger browser autofill detection (delay gives Chrome time to autofill)
    setTimeout(() => {
      if (emailRef.current?.value) {
        emailRef.current.focus();

      }
      if (passwordRef.current?.value) {
        passwordRef.current.focus();

      }
    }, 10);
  }, []);


  useEffect(() => {
    // Trigger browser autofill detection (delay gives Chrome time to autofill)
    setTimeout(() => {
      console.log("its starts")
      if (emailRef.current?.value) {
        emailRef.current.focus();

      }
      if (passwordRef.current?.value) {
        passwordRef.current.focus();

      }
    }, 10);
  }, []);


  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmitForm = (values, { setSubmitting }) => {
    let payload = {
      email: values.email,
      password: values.password
    };
    AuthApiService.login(payload)
      .then((response) => {
          setSnackData({
            show: true,
            message: API_SUCCESS_MESSAGE.LOGIN_SUCCESS,
            type: "success",
          });
          login(response?.access_token,"admin");
          navigate("/admin/dashboard");
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message: errResponse?.response?.data?.error || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
        setSubmitting(false);
      });
  };

  const handleRedirection = (link) => {
    navigate(link);
  };

  return (
    <>
      <AuthWrapper>
        <Formik
          initialValues={{
            email: "",
            password: "",
            submit: null,
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email(LOGIN_PAGE.EMAIL_ERROR)
              .max(255)
              .required(LOGIN_PAGE.EMAIL_REQUIRED_MESSAGE),
            password: Yup.string()
              .max(255)
              .required(LOGIN_PAGE.PASSWORD_REQUIRED_MESSAGE),
          })}
          onSubmit={handleSubmitForm} // Using Formik's onSubmit directly
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <form noValidate onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography>Login</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <TextField
                      required
                      id="email-login"
                      type="email"
                      value={values.email}
                      label={LOGIN_PAGE.EMAIL}
                      name="email"
                      inputRef={emailRef}
                      InputLabelProps={{ shrink: true }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder={LOGIN_PAGE.EMAIL_INPUT_PLACEHOLDER}
                      fullWidth
                      error={Boolean(touched.email && errors.email)}
                    />
                  </Stack>
                  {touched.email && errors.email && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-email-login"
                    >
                      {errors.email}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <TextField
                      required
                      id="password-login"
                      type={showPassword ? "text" : "password"}
                      value={values.password}
                      label="Password"
                      name="password"
                      inputRef={passwordRef}
                      InputLabelProps={{ shrink: true }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder={LOGIN_PAGE.PASSWORD_INPUT_PLACEHOLDER}
                      fullWidth
                      error={Boolean(touched.password && errors.password)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <EyeOutlined />
                              ) : (
                                <EyeInvisibleOutlined />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>
                  {touched.password && errors.password && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-password-login"
                    >
                      {errors.password}
                    </FormHelperText>
                  )}
                </Grid>

                {errors.submit && (
                  <Grid item xs={12}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Button
                    disableElevation
                    disabled={isSubmitting} // Button is disabled if form is submitting
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    {LOGIN_PAGE.LOGIN_BUTTON}
                  </Button>
                </Grid>
                <Grid item xs={12} sx={{ mt: -1 }}>

                    <Link
                      variant="h6"
                      color="text.primary"
                      onClick={(e) => handleRedirection("/forgotPassword")}
                      sx={{
                        fontSize: "14px",
                        justifySelf: "center",
                        textDecoration: "none",
                        display:"block",
                        cursor:"pointer"
                      }}
                    >
                      {LOGIN_PAGE.FORGOT_PASSWORD}
                    </Link>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>

        <Snackbar
          style={{ top: "80px" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackData.show}
          autoHideDuration={3000}
          onClose={() => setSnackData({ show: false })}
        >
          <Alert
            onClose={() => setSnackData({ show: false })}
            severity={snackData.type}
          >
            {snackData.message}
          </Alert>
        </Snackbar>
      </AuthWrapper>
    </>
  );
}

Login.propTypes = {
  isDemo: PropTypes.bool,
};
